module.exports = __webpack_public_path__ + "img/login-free-ecshopx.a0a58b91.jpg";